<template>
  <div class="user">
    <!--<img class="user-poster" src="https://img.yzcdn.cn/public_files/2017/10/23/8690bb321356070e0b8c4404d087f8fd.png">-->
    <div class='back'>
      <div>
        <!-- <i @click='onClickLeft'></i> -->
      </div>
    </div>
    <div class="user-top">
      <div class='user-top-main clearfix'>
        <div class="photo">
        </div>
        <div class="base-info">
          <p>Zemel</p>
          <span @click='toAddress'>收货地址管理<i class="van-icon van-icon-arrow"></i></span>
        </div>
        <div class='user-cart_all clearfix'>
          <div>
            <router-link :to='{name:"cart"}'>
              <span>{{this.selectGoods.length}}</span>
              <p>购物车</p>
            </router-link>
          </div>
          <div>
            <router-link :to='{name:"bookmark"}'>
              <span>{{bookMark.length}}</span>
              <p>收藏夹</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <router-link :to="{name:'/orderList'}">
      <div class='order_man clearfix'>
        <div>
          <i></i>
          <span>订单管理</span>
        </div>
        <div>
          <i></i>
        </div>
      </div>
    </router-link>
    <van-row class="user-links">
      <van-col span="6"
               class='topay'>
        <router-link :to="{name:'/orderList',params: {active: 1}}">
          <van-icon name="pending-payment" />
          待付款
        </router-link>
      </van-col>
      <van-col span="6"
               class='tologins'>
        <van-icon name="pending-orders" />
        <router-link :to="{name:'/orderList',params: {active: 2}}">
          待收货
        </router-link>
      </van-col>
      <van-col span="6"
               class='torecive'>
        <router-link :to="{name:'/orderList',params: {active: 3}}">
          <van-icon name="pending-evaluate" />
          待收货
        </router-link>
      </van-col>
      <!-- <van-col span="6">
        <van-icon name="logistics" />
        退换货
      </van-col> -->
    </van-row>

    <!-- <van-cell-group class="user-group">
      <router-link to="/orderList">
        <van-cell icon="records"
                  title="全部订单"
                  is-link />
      </router-link>
    </van-cell-group> -->

    <!-- <van-cell-group>
      <van-cell icon="exchange"
                title="我的积分"
                is-link />
      <van-cell icon="gold-coin"
                title="我的优惠券"
                is-link />
      <van-cell icon="gift"
                title="我收到的礼物"
                is-link />
    </van-cell-group> -->
  </div>
</template>

<script>
export default {
  name: 'my',
  data () {
    return {
      selectGoods: [],//购物车的数组
      bookMark: [],//收藏夹的数组

    }
  },
  mounted () {
    //debugger
    this.selectGoods = this.$store.state.selectGoods;
    this.$store.state.bookMark = this.unique(this.$store.state.bookMark);
    this.bookMark = this.$store.state.bookMark;
  },
  methods: {
    onClickLeft () {
      this.$router.push({ name: 'home' });
    },
    //地址列表q
    toAddress () {
      this.$router.push('/addressList');
    },
    unique (arr) {
      let hashTable = {};
      let newArr = [];
      for (let i = 0, l = arr.length; i < l; i++) {
        if (!hashTable[arr[i].id]) {
          hashTable[arr[i].id] = true;
          newArr.push(arr[i]);
        }
      }
      return newArr;
    }
  }
};
</script>

<style lang="less">
.user {
  & > .back {
    height: 2rem;
    padding: 0.3rem;
    background: rgb(255, 144, 0);

    & > div {
      & > i {
        width: 0.34rem;
        height: 0.34rem;
        display: inline-block;
        background: url("../../../static/image/myOrder/ios/back.png") no-repeat
          center center;
      }
    }
  }
  &-poster {
    width: 7.5rem;
    height: 4rem;
    display: block;
  }
  &-group {
    margin-bottom: 0.3rem;
  }
  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;
    .van-icon {
      display: block;
      font-size: 24px;
      margin-bottom: 0.12rem;
    }
  }
  &-top {
    width: 6.9rem;
    margin: 0 0.3rem;
    height: 3rem;
    background: #fff;
    display: flex;
    align-items: center;
    font-size: 0.38rem;
    margin-top: -0.95rem;
    border-radius: 0.2rem;

    .user-top-main {
      background: #fff;
      width: 100%;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
      border-radius: 0.2rem;
      padding: 0.34rem 0.34rem 0.38rem;

      .photo {
        float: left;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        background-size: 100%;
        background: url("../../../static/image/myOrder/ios/touxiang.png")
          no-repeat center center;
      }
      .base-info {
        float: left;
        margin-left: 5%;
        line-height: 0.55rem;
        & > p {
          color: rgb(51, 51, 51);
          font-weight: bold;
          font-size: 0.32rem;
        }
        span {
          color: rgb(153, 153, 153);
          font-size: 0.22rem;
          .van-icon {
            position: relative;
            top: 0.04rem;
          }
        }
      }
      .user-cart_all {
        float: left;
        width: 100%;
        margin-top: 0.34rem;
        & > div {
          float: left;
          color: rgb(51, 51, 51);
          margin-right: 1.06rem;
          &:nth-child(1) {
            margin-left: 0.52rem;
          }
          & > a {
            & > span {
              display: inline-block;
              width: 100%;
              text-align: center;
              font-size: 0.28rem;
              margin-bottom: 0.1rem;
            }
            & > p {
              font-size: 0.24rem;
            }
          }
        }
      }
    }
  }
}

.order_man {
  margin-top: 0.32rem;
  padding: 0 0.62rem;
  margin-bottom: 0.32rem;

  & > div {
    &:nth-child(1) {
      float: left;
      vertical-align: middle;

      i {
        display: inline-block;
        width: 0.44rem;
        height: 0.44rem;
        background: rgb(255, 144, 0);
      }
      span {
        vertical-align: 5px;
        display: inline-block;
        color: rgb(51, 51, 51);
        font-size: 0.32rem;
        margin-left: -0.1rem;
      }
    }
    &:nth-child(2) {
      float: right;
      i {
        display: block;
        width: 0.28rem;
        height: 1rem;
        background: url("../../../static/image/myOrder/ios/more.png") no-repeat
          center center;
      }
    }
  }
}

.topay {
  font-size: 0.24rem;
  color: rgb(51, 51, 51);
  .van-icon-pending-payment {
    &::before {
      content: "";
    }
    &:nth-child(1) {
      background: url("../../../static/image/myOrder/ios/payment.png") no-repeat
        center center;
    }
  }
}
.tologins {
  font-size: 0.24rem;
  color: rgb(51, 51, 51);
  .van-icon-pending-orders {
    &::before {
      content: "";
    }
    &:nth-child(1) {
      background: url("../../../static/image/myOrder/ios/send.png") no-repeat
        center center;
    }
  }
}
.torecive {
  font-size: 0.24rem;
  color: rgb(51, 51, 51);
  .van-icon-pending-evaluate {
    &::before {
      content: "";
    }
    &:nth-child(1) {
      background: url("../../../static/image/myOrder/ios/receiving.png")
        no-repeat center center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/my/my.vue